import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import speciesList from "../../../type/speciesList";
import i18n from "../../../i18n";
import { defaultLang, secondLang } from "../../../utils";
const AppliedIncidents: React.FC<{
  type: string;
  value: speciesList[];
  removeFilter: () => void;
  isReportFilter?: boolean;
}> = ({ type, value, removeFilter, isReportFilter }) => {
  const removerFilter = () => {
    removeFilter();
  };
  return (
    <div className="applied-filter-item">
      <p className="text-xs text-default-text">
        {type} :{" "}
        {value.map((c, index) => (
          <span key={c.slug}>
            {i18n.language === secondLang
              ? c.name_transes[secondLang] === ""
                ? c.name_transes[defaultLang]
                : c.name_transes[secondLang]
              : c.name_transes[defaultLang]}
            {index < value.length - 1 ? ", " : ""}
          </span>
        ))}
      </p>

      {!isReportFilter ? (
        <span className="relative top-[2px] pl-2" onClick={removerFilter}>
          <FontAwesomeIcon icon={faXmark} />
        </span>
      ) : (
        ""
      )}
    </div>
  );
};

export default AppliedIncidents;
